import React from "react";

export const Menu = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.3333 5.86364H2.66667C2.29867 5.86364 2 5.55818 2 5.18182C2 4.80545 2.29867 4.5 2.66667 4.5H21.3333C21.702 4.5 22 4.80545 22 5.18182C22 5.55818 21.702 5.86364 21.3333 5.86364Z"
        fill="#414042"
      />
      <path
        d="M21.3333 12.6818H2.66667C2.29867 12.6818 2 12.3764 2 12C2 11.6236 2.29867 11.3182 2.66667 11.3182H21.3333C21.702 11.3182 22 11.6236 22 12C22 12.3764 21.702 12.6818 21.3333 12.6818Z"
        fill="#414042"
      />
      <path
        d="M21.3333 19.5H2.66667C2.29867 19.5 2 19.1952 2 18.8182C2 18.4411 2.29867 18.1364 2.66667 18.1364H21.3333C21.702 18.1364 22 18.4411 22 18.8182C22 19.1952 21.702 19.5 21.3333 19.5Z"
        fill="#414042"
      />
    </svg>
  );
};
